<template>
  <header class="header">
    <div class="header-content mdHidden">
      <div class="header-left">
        <div class="header-left-content">
          <img src="../assets/logo.png" class="logo" alt="logo" />
          <span class="title">校易多</span>
        </div>
        <nav class="">
          <ul>
            <li ><router-link to="/home"  active-class="active">首页</router-link></li>
            <li ><router-link to="/online" active-class="active">功能在线</router-link></li> 
            <li><router-link to="/service" active-class="active">服务支持</router-link></li>
          </ul>
        </nav>
      </div>
      <div class="header-right">
        <button class="btn try-btn"><a href="https://edu.xiaoyiduo.cn" target="_blank" style="     color: #fff;">免费试用</a></button>
        <button class="btn login-btn"><a href="https://edu.xiaoyiduo.cn" target="_blank" style="     color: #4a90e2;">立即登录</a></button>
      </div>
    </div>
    <div class="mdShow">
      <div class="md-flex">
        <div class="header-left-content">
          <img src="../assets/logo.png" class="logo" alt="logo" />
          <span class="title">校易多</span>
        </div>
        <div>
          <img src="@/assets/006.png" class="more-btn" @click="handleClick" />
        </div>
      </div>
       <nav class="md-show" v-show="isShow">
          <ul>
            <li ><router-link to="/home" active-class="active">首页</router-link></li>
            <li><router-link to="/online" active-class="active">功能在线</router-link></li>
            <li><router-link to="/service" active-class="active">服务支持</router-link></li>
            <li><a href="https://edu.xiaoyiduo.cn" target="_blank">免费试用</a></li>
            <li><a href="https://edu.xiaoyiduo.cn" target="_blank">立即登录</a></li>
          </ul>
        </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    handleClick() {
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style scoped>
.header {
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 70%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  align-items: center;
}
.header-left-content {
  display: flex;
  align-items: center;
}
.header-left .logo {
  width: 40px;
  margin-right: 10px;
}

.header-left .title {
  margin: 0;
  font-size: 24px;
  color: #000;
}

.header nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.header nav ul li {
  margin-left: 2rem;
}

.header nav ul li a {
  color: #666666;
  text-decoration: none;
  font-size: 16px;
  transition: opacity 0.3s;
}
.header nav ul li a.active {
  color: #4a90e2;
  font-weight: bold;
}

.btn {
  width: 120px;
  height: 40px;
  background: #4a90e2;
  border-radius: 25px;
  border: 1px solid #4a90e2;
  color: #fff;
  margin-right: 20px;
  cursor: pointer;
}
.login-btn {
  background: #fff;
  color: #4a90e2;
  border: 1px solid #4a90e2;
}
.mdShow {
  display: none;
}
.mdShow .more-btn {
  width: 20px;
  height: 20px;
}
.mdShow .logo {
  width: 30px;
  height: 30px;
}
.mdShow .md-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.6rem;
}
.mdShow nav ul{
    flex-direction: column;
}
a{
      text-decoration: none;
 
}
@media (max-width: 950px) {
  .mdHidden {
    display: none;
  }
  .mdShow {
    display: block;
  }
}
</style>
